<template>
  <base-modal
    id="outreach_detail_modal"
    :key="key"
    :show="true"
    size="modal-xl"
    :show-close-button="true"
    @closed="onClosed"
  >
    <div class="container">
      <div class="modal-heading">
        <base-heading
          class="w-auto mr-2 d-inline"
        >
          {{ brand }}
        </base-heading>
        <base-text
          light
          inline
        >
          - {{ product }}
        </base-text>
      </div>
      <base-text
        size="md"
        max-width="800"
        light
        trim
      >
        {{ url }}
      </base-text>
      <base-loading
        v-if="loading"
        :show="true"
      />
      <table
        v-else
        class="mt-4"
        cellpadding="0"
      >
        <tbody>
          <tr
            v-for="({date, event, url, outreach: {customer: {email}}}, index) in clicks"
            :key="`click_${index}`"
          >
            <td>
              <base-text
                class="text-uppercase date spaced"
                nowrap
              >
                {{ date | nicedate('custom', 'M/DD/YY') }}&nbsp;&nbsp;&nbsp;{{ date | nicedate('xsmall') }}&nbsp;
              </base-text>
            </td>
            <td>
              <base-text
                light
                muted
                class="text-capitalize mx-2"
                size="md"
              >
                {{ event }}
              </base-text>
            </td>
            <td>
              <base-text
                semibold
                size="md"
              >
                {{ email }}
              </base-text>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </base-modal>
</template>
<script>
export default {

  name: 'ClientClickEventsModal',
  props: {
    brand: {
      type: String,
      default: '',
    },
    product: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    clicks: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      key: Date.now(),
    };
  },
  methods: {
    onClosed() {
      this.$emit('closed');
      this.key = Date.now();
    },
  },
};
</script>
<style lang="scss"
  scoped>
.container {
  padding: calc(48px - 1rem) calc(56px - 1rem);
}
.url {

}
.date {
  font-size: 11px;
  color: $gray-light-2 !important;
  &.spaced {
    letter-spacing: 0.7772px;
  }
}
::v-deep .modal-dialog {
  max-width: 940px;
}

table {
  border-spacing: 0;

  & tbody {
    & tr {
      padding: 0;

      & td {
        & a {
          margin: 0 !important;
        }
      }
    }
  }
}

.black {
  color: $black;
}

.modal-heading {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
